import { useContext } from "react";
import { PermissionContext } from "@/contexts/PermissionContext";

export function usePermissions() {
  const context = useContext(PermissionContext);
  if (!context) throw new Error("usePermissions deve ser usado dentro de PermissionProvider.");
  return context;
}
